// import Pagination from './Pagination';
import React from "react";
import Loadable from "../../react-loadable";
const Pagination = Loadable({
  loader: () => import("./Pagination"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
export default Pagination;



// WEBPACK FOOTER //
// ./_antd1.11.2/pagination/index.jsx